/**
 * Bundle math — computed over the cart.
 *
 * Groups cart items by `bundleId` and, for each complete bundle (qty matches
 * `bundleQty`), locks the net price to `bundlePrice`. Returns a discount delta
 * the drawer can subtract from the raw cart total so the visible total matches
 * the Shiprocket Fastrr auto-discount applied at checkout.
 *
 * Also surfaces whether any bundle in the cart grants a free gift.
 */

export function computeBundles(cart) {
  const groups = {};
  cart.forEach((line) => {
    if (!line.bundleId || line.isGift) return;
    if (!groups[line.bundleId]) {
      groups[line.bundleId] = {
        bundleId: line.bundleId,
        bundleName: line.bundleName || "Bundle",
        bundlePrice: line.bundlePrice || 0,
        bundleQty: line.bundleQty || 0,
        bundleHasGift: !!line.bundleHasGift,
        items: [],
      };
    }
    const g = groups[line.bundleId];
    for (let i = 0; i < (line.qty || 0); i++) {
      g.items.push({ id: line.id, price: line.price || 0, name: line.name });
    }
  });

  const summaries = [];
  let totalDiscount = 0;
  let hasActiveGift = false;

  Object.values(groups).forEach((g) => {
    const complete = g.items.length === g.bundleQty;
    const raw = g.items.reduce((s, i) => s + i.price, 0);
    const net = complete ? g.bundlePrice : raw;
    const discount = complete ? Math.max(0, raw - g.bundlePrice) : 0;
    totalDiscount += discount;
    if (complete && g.bundleHasGift) hasActiveGift = true;
    summaries.push({
      ...g,
      itemCount: g.items.length,
      complete,
      raw,
      net,
      discount,
    });
  });

  return { summaries, totalDiscount, hasActiveGift };
}
